"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/radio/style/index.js
// module id = 99
// module chunks = 1